/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { PERMISSIONS } from '@squiz/dxp-auth';
import { ICON_CHAT_UNREAD, ICON_CONTENT_PASTE_SEARCH } from '@squiz/sds';
import { DashboardCardProps } from 'apps/console-core/src/Components/DashboardCard/DashboardCard.props';
import { TENANT_FEATURE_FLAGS } from 'apps/console-core/src/Constants/FeatureFlags.constants';
import { screenPaths } from './ScreenPaths.constants';
import { AI_STRINGS } from './Strings.constants';

export const AI_CHATBOTS_DASHBOARD_CARD: DashboardCardProps = {
  description: AI_STRINGS.aiChatbotsDescription,
  featureFlag: TENANT_FEATURE_FLAGS.CHATBOTS_ACCESS,
  icon: ICON_CHAT_UNREAD,
  link: screenPaths.aiChatbots,
  permission: PERMISSIONS.dxpAi.CHATBOT_READ,
  title: AI_STRINGS.aiChatbots,
};

export const SEMANTIC_AUDITOR_DASHBOARD_CARD: DashboardCardProps = {
  description: AI_STRINGS.semanticAuditorDescription,
  featureFlag: TENANT_FEATURE_FLAGS.CONTENT_TOOLS_ACCESS,
  icon: ICON_CONTENT_PASTE_SEARCH,
  link: screenPaths.semanticAuditor,
  permission: PERMISSIONS.dxpAi.CHATBOT_READ,
  title: AI_STRINGS.semanticAuditor,
};

export const CONVERSATIONS_DASHBOARD_CARDS = [AI_CHATBOTS_DASHBOARD_CARD, SEMANTIC_AUDITOR_DASHBOARD_CARD];
